import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import Swal from 'sweetalert2'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    isVisible: false,
    isGenerateInvoiceConfirmed: false,
    created: {},
    data: {
      idInvoiceType: '',
      idPaymentWay: '',
      idBatchNumber: '',
      idInvoiceStatus: '',
      paymentDeadline: '',
      sellDate: '',
      positions: []
    }
  },
  getters: {
    isVisible: (state) => state.isVisible,
    data: (state) => state.data,
    isGenerateInvoiceConfirmed: (state) => state.isGenerateInvoiceConfirmed,
    created: (state) => state.created
  },
  mutations: {
    toggleModal (state) {
      state.isVisible = !state.isVisible
    },
    setGenerateInvoiceConfirmed (state) {
      state.isGenerateInvoiceConfirmed = true
    },
    setCreated (state, payload) {
      state.created = payload
    }
  },
  actions: {
    async generateInvoice ({ commit, state }) {
      Swal({
        title: Vue.prototype.$lang.t('views.exsbsettlements.show.generateInvoiceQuestion') + '?',
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: Vue.prototype.$lang.t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: Vue.prototype.$lang.t('buttons.cancel')
      }).then(async (result) => {
        if (result) {
          commit('setGenerateInvoiceConfirmed')
          let data = {
            invoiceDocumentType: 1,
            idInvoiceType: parseInt(getId(state.data.invoiceType)),
            idPaymentWay: parseInt(getId(state.data.paymentWay)),
            idBatchNumber: parseInt(getId(state.data.batchNumber)),
            idInvoiceStatus: parseInt(getId(state.data.invoiceStatus)),
            paymentDeadline: Vue.prototype.$moment(state.data.paymentDeadline).format('YYYY-MM-DD'),
            positions: state.data.positions.map(position => parseInt(getId(position['@id']))),
            sellDate: Vue.prototype.$moment(state.data.sellDate).format('YYYY-MM-DD')
          }
          const response = await new ApiService('e_x_s_b_invoices/generate_from_positions').post(data)
          commit('setCreated', response)
        }
      })
    }
  }
}
